/**
 * §02 RECORD works カードカルーセル
 *
 * PC: ジグザグ 2 段 (.artecs-record__carousel × 2) — 矢印で 1 枚ずつ移動
 * SP: 1 枚見せ 6 枚無限ループ (.artecs-record__carousel-sp) — 先頭/末尾にクローン挿入し
 *     services-tabs.js と同じ pattern でスクロール検知 → クローン上ならジャンプ
 */
( function () {
	'use strict';

	/* ============ PC: ジグザグ 2 段カルーセル ============ */

	function nearestItem( track, items ) {
		var trackRect = track.getBoundingClientRect();
		var centerX = trackRect.left + trackRect.width / 2;
		var bestIdx = 0;
		var bestDist = Infinity;
		for ( var i = 0; i < items.length; i++ ) {
			var rect = items[ i ].getBoundingClientRect();
			var itemCenter = rect.left + rect.width / 2;
			var dist = Math.abs( itemCenter - centerX );
			if ( dist < bestDist ) {
				bestDist = dist;
				bestIdx = i;
			}
		}
		return bestIdx;
	}

	function setupPcCarousel( root ) {
		var track = root.querySelector( '.artecs-record__carousel-track' );
		if ( ! track ) return;
		var realItems = Array.prototype.slice.call(
			track.querySelectorAll( '.artecs-record__carousel-item' )
		);
		if ( realItems.length <= 1 ) {
			var navs = root.querySelectorAll( '.artecs-record__carousel-nav' );
			for ( var n = 0; n < navs.length; n++ ) {
				navs[ n ].style.display = 'none';
			}
			return;
		}

		// クローンを 1 セット末尾に複製 → track が container より広くなり scroll 可能に。
		// 末尾までスクロールしたら無 animation で先頭に戻し、無限ループ感を出す。
		var realLen = realItems.length;
		for ( var c = 0; c < realLen; c++ ) {
			var clone = realItems[ c ].cloneNode( true );
			clone.classList.add( 'is-clone' );
			clone.setAttribute( 'aria-hidden', 'true' );
			track.appendChild( clone );
		}
		var allItems = Array.prototype.slice.call(
			track.querySelectorAll( '.artecs-record__carousel-item' )
		);

		var prev = root.querySelector( '[data-record-carousel-prev]' );
		var next = root.querySelector( '[data-record-carousel-next]' );

		// 1 step = card width + gap
		function getStep() {
			if ( allItems.length < 2 ) return 0;
			return allItems[ 1 ].getBoundingClientRect().left - allItems[ 0 ].getBoundingClientRect().left;
		}

		function go( delta ) {
			var step = getStep();
			if ( step <= 0 ) return;
			var newLeft = track.scrollLeft + delta * step;
			var maxLeft = step * realLen; // 末尾クローン (index realLen+) に入る位置
			if ( newLeft >= maxLeft ) {
				// 末尾クローンに到達 → 先頭にジャンプして 1 step 進める
				track.scrollTo( { left: 0, behavior: 'auto' } );
				setTimeout( function () {
					track.scrollTo( { left: step, behavior: 'smooth' } );
				}, 0 );
				return;
			}
			if ( newLeft < 0 ) {
				// 先頭の前 → 末尾実 item へジャンプして 1 step 戻る
				track.scrollTo( { left: maxLeft, behavior: 'auto' } );
				setTimeout( function () {
					track.scrollTo( { left: maxLeft - step, behavior: 'smooth' } );
				}, 0 );
				return;
			}
			track.scrollTo( { left: newLeft, behavior: 'smooth' } );
		}

		if ( prev ) prev.addEventListener( 'click', function () { go( -1 ); } );
		if ( next ) next.addEventListener( 'click', function () { go( 1 ); } );
	}

	/* ============ SP: 1 枚見せ無限ループ ============ */

	function setupSpCarousel( root ) {
		var track = root.querySelector( '.artecs-record__carousel-sp-track' );
		if ( ! track ) return;
		var realItems = Array.prototype.slice.call(
			track.querySelectorAll( '.artecs-record__carousel-item' )
		);
		if ( realItems.length <= 1 ) {
			return; // 1 枚しかなければループ不要
		}

		// 先頭末尾にクローンを挿入 (無限ループ用)
		var firstClone = realItems[ 0 ].cloneNode( true );
		var lastClone = realItems[ realItems.length - 1 ].cloneNode( true );
		firstClone.classList.add( 'is-clone' );
		lastClone.classList.add( 'is-clone' );
		firstClone.setAttribute( 'aria-hidden', 'true' );
		lastClone.setAttribute( 'aria-hidden', 'true' );
		track.insertBefore( lastClone, realItems[ 0 ] );
		track.appendChild( firstClone );

		var allItems = Array.prototype.slice.call(
			track.querySelectorAll( '.artecs-record__carousel-item' )
		);

		// 初期位置を「最初の実カード (= index 1)」にセット
		function centerItem( el, smooth ) {
			// scrollIntoView は block(縦) も動かすため、ページ全体が works セクションへ
			// スクロールしてしまう（=ロード/リロードで先頭に居ても works に飛ぶ不具合）。
			// track の横スクロールのみで中央寄せし、ページの縦位置は一切動かさない。
			var trackRect = track.getBoundingClientRect();
			var elRect = el.getBoundingClientRect();
			var delta =
				elRect.left + elRect.width / 2 - ( trackRect.left + trackRect.width / 2 );
			track.scrollTo( {
				left: track.scrollLeft + delta,
				behavior: smooth ? 'smooth' : 'auto',
			} );
		}
		// 描画後に位置調整
		setTimeout( function () {
			centerItem( allItems[ 1 ], false );
		}, 0 );

		// スクロール停止後にクローン上だったら実カードへジャンプ
		var scrollTimer = null;
		track.addEventListener( 'scroll', function () {
			if ( scrollTimer ) clearTimeout( scrollTimer );
			scrollTimer = setTimeout( function () {
				var idx = nearestItem( track, allItems );
				if ( idx === 0 ) {
					// 末尾クローン上 → 実 最後尾 (index len-2) にジャンプ
					centerItem( allItems[ allItems.length - 2 ], false );
				} else if ( idx === allItems.length - 1 ) {
					// 先頭クローン上 → 実 先頭 (index 1) にジャンプ
					centerItem( allItems[ 1 ], false );
				}
			}, 120 );
		} );

		// 矢印 click
		var prev = root.querySelector( '[data-record-carousel-sp-prev]' );
		var next = root.querySelector( '[data-record-carousel-sp-next]' );
		function go( delta ) {
			var cur = nearestItem( track, allItems );
			var target = cur + delta;
			if ( target < 0 ) target = 0;
			if ( target > allItems.length - 1 ) target = allItems.length - 1;
			centerItem( allItems[ target ], true );
		}
		if ( prev ) prev.addEventListener( 'click', function () { go( -1 ); } );
		if ( next ) next.addEventListener( 'click', function () { go( 1 ); } );
	}

	function init() {
		// PC: 各 .artecs-record__carousel に対して setupPcCarousel
		var pcCarousels = document.querySelectorAll( '.artecs-record__carousel' );
		for ( var i = 0; i < pcCarousels.length; i++ ) {
			setupPcCarousel( pcCarousels[ i ] );
		}
		// SP: .artecs-record__carousel-sp に対して setupSpCarousel
		var spCarousels = document.querySelectorAll( '.artecs-record__carousel-sp' );
		for ( var j = 0; j < spCarousels.length; j++ ) {
			setupSpCarousel( spCarousels[ j ] );
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
